import React from 'react'

export const Alert = () => {
  return (
    <div className='alert-icon'>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="white"/>
            <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="url(#paint0_linear_202_7275)"/>
            <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="white"/>
            <path d="M8.00016 4.21875C7.8141 4.21875 7.64395 4.37687 7.65641 4.5625L7.82828 9.20312C7.82828 9.24871 7.84639 9.29243 7.87862 9.32466C7.91085 9.35689 7.95457 9.375 8.00016 9.375C8.04574 9.375 8.08946 9.35689 8.12169 9.32466C8.15392 9.29243 8.17203 9.24871 8.17203 9.20312L8.34391 4.5625C8.35637 4.37687 8.18621 4.21875 8.00016 4.21875Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 11.7812C8.18985 11.7812 8.34375 11.6273 8.34375 11.4375C8.34375 11.2477 8.18985 11.0938 8 11.0938C7.81015 11.0938 7.65625 11.2477 7.65625 11.4375C7.65625 11.6273 7.81015 11.7812 8 11.7812Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <defs>
            <linearGradient id="paint0_linear_202_7275" x1="1" y1="8" x2="15" y2="8" gradientUnits="userSpaceOnUse">
            <stop stop-color="#A71616"/>
            <stop offset="1" stop-color="#FF1010"/>
            </linearGradient>
            </defs>
        </svg>
    </div>
  )
}
